//function scrollFunction(){document.body.scrollTop>100||document.documentElement.scrollTop>100?mybutton.style.display="block":mybutton.style.display="none"}function topFunction(){document.body.scrollTop=0,document.documentElement.scrollTop=0}$("#product-list").length>0&&document.addEventListener("DOMContentLoaded",(function(){new Ajaxinate({container:"#product-list",pagination:".pagination__next_link"})})),mybutton=document.getElementById("myBtn"),window.onscroll=function(){scrollFunction()},$(document).ready((function(){$(".reviewMain .reviewsBlock").length>0&&$(".reviewMain .reviewsBlock").owlCarousel({items:3,itemsCustom:!1,scrollPerPage:!0,slideSpeed:500,stopOnHover:!0,itemsDesktop:[1199,2],itemsDesktopSmall:[980,1],itemsTablet:[979,1],itemsTabletSmall:!1,itemsMobile:[767,1],itemsScaleUp:!1,navigation:!0,navigationText:["< previous review","next review >"]}),$(".featured-collections .ProductList").length>0&&$(".featured-collections .ProductList").owlCarousel({items:3,itemsCustom:!1,scrollPerPage:!0,slideSpeed:500,stopOnHover:!0,itemsDesktop:[1199,2],itemsDesktopSmall:[980,1],itemsTablet:[979,1],itemsTabletSmall:!1,itemsMobile:[767,1],itemsScaleUp:!1,navigation:!0,navigationText:["previous","next"]}),$(".customInfo .info_text_inner").length>0&&$(".customInfo .info_text_inner").owlCarousel({items:1,itemsCustom:!1,scrollPerPage:!0,slideSpeed:500,stopOnHover:!0,itemsDesktop:[1199,1],itemsDesktopSmall:[980,1],itemsTablet:[979,1],itemsTabletSmall:!1,itemsMobile:[767,1],itemsScaleUp:!1,navigation:!0,navigationText:["previous","next"]}),$(".single-slide .slide-list").length>0&&$(".single-slide .slide-list").owlCarousel({items:1,itemsCustom:!1,autoPlay:false,autoplayTimeout:4e3,scrollPerPage:!0,loop:!0,slideSpeed:400,stopOnHover:!0,accessibility:true,itemsDesktop:[1199,1],itemsDesktopSmall:[980,1],itemsTablet:[979,1],itemsTabletSmall:!1,itemsMobile:[767,1],itemsScaleUp:!1,pagination:!0,navigation:!1,navigationText:["previous","next"]}),$(".regular").slick({infinite:!0,slidesToShow:1,slidesToScroll:1,autoplay:!0,autoplaySpeed:2e3,fade:!0,speed:700,arrows:!0,cssEase:"linear"})}));var NS={wrap:function(){$("#shopify-section-announcement-bar, #shopify-section-header").wrapAll("<div class='top_wrap'>")},header:function(){$("#shopify-section-header");var e=$(".top_wrap");e&&(e.addClass("animated"),$(window).scrollTop()>300?e.css({transform:"translate(0, -100%)"}):e.css({transform:"translate(0, 0)"}))},main:function(){$("#shopify-section-header"),$("#shopify-section-announcement-bar");var e=$(".top_wrap"),t=$("#main");t.removeAttr("style"),t&&(t.removeAttr("style"),t.css({"padding-top":e.outerHeight()+"px"}))},video_modal:function(){$(".js-video-button").length>0&&$(".js-video-button").modalVideo()},common:function(){$(".text_popup a").on("click",(function(){return $(".box-modal_close").trigger("click"),!1}))},init:function(){this.wrap(),this.common(),this.header(),this.main(),this.video_modal()}};$(document).on("ready",(function(){NS.init(),$(window).trigger("resize"),$(window).on("resize",(function(){NS.main()})),$(window).on("scroll",(function(){NS.header()}))})),jQuery(document).ready((function(){jQuery("#pop-up-click").click((function(){jQuery.blockUI({message:jQuery("#question"),css:{width:"275px"},onOverlayClick:jQuery.unblockUI})})),jQuery(".popup_video").click((function(){jQuery.blockUI({message:jQuery("#popup_video"),css:{width:"275px"},onOverlayClick:jQuery.unblockUI})})),jQuery("#yes").click((function(){jQuery.unblockUI()})),jQuery("#yes1").click((function(){jQuery.unblockUI()})),jQuery("#close").click((function(){jQuery.unblockUI()}))})),document.addEventListener("variant:changed",(function(e){e.detail.variant}));


// Select all .nav-bar__link elements within .nav-bar__item--static
const links = document.querySelectorAll('.nav-bar__item--static .nav-bar__link');

// Loop through each link, prevent default action, and add tabindex="0"
links.forEach(link => {
  // Prevent the default action of the link, but don't stop the dropdown functionality
  link.addEventListener('click', (e) => {
    e.preventDefault();
  });

  // Add tabindex="0" to make it focusable
  link.setAttribute('tabindex', '0');
});

$("br").attr("aria-hidden", "true");





document.addEventListener('DOMContentLoaded', function() {
    const slides = document.querySelectorAll('.splide__slide');
  
    slides.forEach((slide) => {
      // Remove invalid role
      slide.removeAttribute('role');
      
      // Set correct role for slides
      slide.setAttribute('role', 'group'); // or 'listitem'
      
      // Keep existing attributes
      slide.setAttribute('aria-roledescription', 'slide');
      
      // Optional: Double-check if aria-label is present
      if (!slide.hasAttribute('aria-label')) {
        const index = slide.getAttribute('aria-label') || 'Slide';
        slide.setAttribute('aria-label', `${index}`);
      }
    });
  });
  



$('a').each(function () {
  // Check if the link is external
  if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://shupbubbys.com/') {
    // Create a span element with warning text
    var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
    // Set attributes for accessibility
    $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
    // Append the warning span inside the link
    $(this).append(warningSpan);
  }
});

// $('.header__action-item-link.hidden-lap').click(function (e) {
//     e.preventDefault();
//     $(this).attr('aria-expanded', function (i, attr) {
//       return attr == 'true' ? 'false' : 'true'
//     });
//   });


document.addEventListener('DOMContentLoaded', function() {
    var backToTopButton = document.getElementById('back-to-top');
    
    window.addEventListener('scroll', function() {
        if (window.scrollY > 300) {
            backToTopButton.style.display = 'block';
        } else {
            backToTopButton.style.display = 'none';
        }
    });
    
    backToTopButton.addEventListener('click', function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Set focus to the top of the page after scrolling
        setTimeout(function() {
            document.getElementById('backtoheader').focus(); // Ensure this element exists
        }, 600); // Adjust the timeout duration to match the scroll duration
    });
});


// $(document).ready(function() {
//     var existCondition = setInterval(function() {
//         if ($('.owl-stage-outer').length) {
//             clearInterval(existCondition);
//             runMyFunction9();
//         }
//     }, 2000);
  
//     function runMyFunction9() {
//         updateAriaHidden();
//         $(".owl-stage-outer").attr("role", "region");
//         $(".owl-stage-outer").attr("aria-label", "Slider");
        
//         $('.owl-carousel').on('changed.owl.carousel', function(event) {
//             updateAriaHidden();
//         });

//         addAccessibilityToNavButtons();
//     }

//     function updateAriaHidden() {
//         $('.owl-item').attr('aria-hidden', 'true');
//         $('.owl-item.active').attr('aria-hidden', 'false');
//     }

//     function addAccessibilityToNavButtons() {
//         $('.owl-prev').attr({
//             'aria-label': 'Previous Slide',
//             'role': 'button',
//             'tabindex': '0'
//         });

//         $('.owl-next').attr({
//             'aria-label': 'Next Slide',
//             'role': 'button',
//             'tabindex': '0'
//         });
//     }
  
//     updateAriaHidden();
  
//     $('.owl-nav').on('click', function() {
//         setTimeout(updateAriaHidden, 100);
//     });
// });

document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      const openDropdown = document.querySelector('.nav-bar__item.is-dropdown-open');
      if (openDropdown) {
        // Remove the open class
        openDropdown.classList.remove('is-dropdown-open');
  
        // Set aria-expanded="false" for accessibility
        const dropdownToggle = openDropdown.querySelector('[aria-expanded="true"]');
        if (dropdownToggle) {
          dropdownToggle.setAttribute('aria-expanded', 'false');
        }
  
        // Hide dropdown menu
        const dropdownMenu = openDropdown.querySelector('.mega-menu');
        if (dropdownMenu) {
          dropdownMenu.setAttribute('aria-hidden', 'true');
        }
      }
    }
  });
  
$(document).on('keydown', function(e) {
  if (e.key === 'Escape') {
      var $accountPopover = $('#account-popover');

      if ($accountPopover.is(':visible') && $accountPopover.attr('aria-hidden') === 'false') {
          // Close the popover
          $accountPopover.attr('aria-hidden', 'true');
          $('.header__action-item-content').removeClass('open');
          $('.header__action-item-link').attr('aria-expanded', 'false');
      }
  }
});